export default "__VITE_ASSET__d445a3b7__"